import Service from "@/services/abstract/service";
import FirebaseStorage from "@/services/firebase/storage";
import Functions from "@/utils/functions";

export default class Arquivos extends Service {
  constructor() {
    super();

    this._colaboradorCollection = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Colaboradores`
    );

    this._campanhasCollection = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Campanhas`
    );

    this._empresasCollection = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Empresas`
    );
  }

  async createLayoutImage(
    empresa,
    cpf,
    campanha,
    nome,
    layoutId,
    imageBase64String
  ) {
    try {
      let imageUploaded = await new FirebaseStorage().uploadLayoutImageBase64(
        imageBase64String
      );

      const arquivosCollection = this._db.collection(
        `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Empresas/${empresa}/Arquivos`
      );

      await arquivosCollection.doc().set({
        ativo: true,
        colaborador: cpf,
        campanha: campanha,
        dataCriacao: new Date(),
        nome: nome,
        layoutId,
        tipo: "image",
        url: imageUploaded.url,
        fileName: imageUploaded.fileName
      });
      return Promise.resolve("Salvo com sucesso");
    } catch (error) {
      console.error(error);
      return Promise.reject(error);
    }
  }

  async createPdfByLayout(empresa, cpf, campanha, nome, layoutId, file) {
    try {
      let pdfUploaded = await new FirebaseStorage().uploadPdf(file);

      const arquivosCollection = this._db.collection(
        `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Empresas/${empresa}/Arquivos`
      );

      await arquivosCollection.doc().set({
        ativo: true,
        colaborador: cpf,
        campanha: campanha,
        dataCriacao: new Date(),
        nome: nome,
        layoutId,
        tipo: "pdf",
        url: pdfUploaded.url,
        fileName: pdfUploaded.fileName
      });
      return Promise.resolve("Salvo com sucesso");
    } catch (error) {
      console.error(error);
      return Promise.reject(error);
    }
  }

  async uploadVideoByColaborador(empresa, cpf, campanha, nome, file) {
    try {
      let videoUploaded = await new FirebaseStorage().uploadVideo(file);

      const arquivosCollection = this._db.collection(
        `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Empresas/${empresa}/Arquivos`
      );

      await arquivosCollection.doc().set({
        ativo: true,
        colaborador: cpf,
        campanha: campanha,
        nome: nome,
        tipo: "video",
        url: videoUploaded.url,
        fileName: videoUploaded.fileName
      });
      return Promise.resolve("Salvo com sucesso");
    } catch (error) {
      console.error(error);
      return Promise.reject(error);
    }
  }

  async uploadImageByColaborador(empresa, cpf, campanha, nome, file) {
    try {
      let imageUploded = await new FirebaseStorage().uploadLayoutImage(file);

      const arquivosCollection = this._db.collection(
        `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Empresas/${empresa}/Arquivos`
      );

      await arquivosCollection.doc().set({
        ativo: true,
        colaborador: cpf,
        campanha: campanha,
        nome: nome,
        tipo: "image",
        url: imageUploded.url,
        fileName: imageUploded.fileName
      });
      return Promise.resolve("Salvo com sucesso");
    } catch (error) {
      console.error(error);
      return Promise.reject(error);
    }
  }

  async uploadPdfByColaborador(empresa, cpf, campanha, nome, file) {
    try {
      let pdfUploaded = await new FirebaseStorage().uploadPdf(file);

      const arquivosCollection = this._db.collection(
        `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Empresas/${empresa}/Arquivos`
      );

      await arquivosCollection.doc().set({
        ativo: true,
        colaborador: cpf,
        campanha: campanha,
        nome: nome,
        tipo: "pdf",
        url: pdfUploaded.url,
        fileName: pdfUploaded.fileName
      });
      return Promise.resolve("Salvo com sucesso");
    } catch (error) {
      console.error(error);
      return Promise.reject(error);
    }
  }

  async listArquivos(empresas, colaboradores, campanhas, ativo) {
    let arrArquivos = [];

    try {
      for (let currentEmpresa of empresas) {
        const arquivosCollection = this._empresasCollection
          .doc(currentEmpresa)
          .collection("Arquivos");

        // Carrega todos os dados dos arquivos por colaborador
        for (let currentColaborador of colaboradores) {
          for (let currentCampanha of campanhas) {
            let arquivosQuerySnapshot = await arquivosCollection
              .where("ativo", "==", ativo)
              .where("colaborador", "==", currentColaborador.cpf)
              .where("campanha", "==", currentCampanha)
              .get();

            if (arquivosQuerySnapshot.empty) continue;

            for (let currentArquivo of arquivosQuerySnapshot.docs) {
              let arquivoInfo = currentArquivo.data();

              let campanhaQuerySnapshot = await this._campanhasCollection
                .doc(currentCampanha)
                .get();
              let campanhaInfo = campanhaQuerySnapshot.exists
                ? campanhaQuerySnapshot.data()
                : { nome: "" };

              arrArquivos.push({
                id: currentArquivo.id,
                colaborador: currentColaborador.nome,
                campanha: campanhaInfo.nome,
                ativo: arquivoInfo.ativo,
                dataCriacao: arquivoInfo.dataCriacao,
                tipo: arquivoInfo.tipo,
                url: arquivoInfo.url,
                nome: arquivoInfo.nome,
                cnpj: currentEmpresa
              });
            }
          }
        }
      }

      let arquivosPublic = await this.listArquivosPublic(
        empresas,
        campanhas,
        ativo
      );

      return Promise.resolve(arrArquivos.concat(arquivosPublic));
    } catch (error) {
      console.error(error);
      return Promise.reject(error);
    }
  }

  async listArquivosPublic(empresas, campanhas, ativo) {
    let arrArquivos = [];

    try {
      for (let currentEmpresa of empresas) {
        const arquivosCollection = this._empresasCollection
          .doc(currentEmpresa)
          .collection("Arquivos");

        for (let currentCampanha of campanhas) {
          let arquivosQuerySnapshot = await arquivosCollection
            .where("ativo", "==", ativo)
            .where("colaborador", "==", "public")
            .where("campanha", "==", currentCampanha)
            .get();

          if (arquivosQuerySnapshot.empty) continue;

          for (let currentArquivo of arquivosQuerySnapshot.docs) {
            let arquivoInfo = currentArquivo.data();

            let campanhaQuerySnapshot = await this._campanhasCollection
              .doc(currentCampanha)
              .get();
            let campanhaInfo = campanhaQuerySnapshot.exists
              ? campanhaQuerySnapshot.data()
              : { nome: "" };

            arrArquivos.push({
              id: arquivoInfo.id,
              colaborador: "PUBLIC",
              campanha: campanhaInfo.nome,
              ativo: arquivoInfo.ativo,
              dataCriacao: arquivoInfo.dataCriacao,
              tipo: arquivoInfo.tipo,
              url: arquivoInfo.url,
              nome: arquivoInfo.nome,
              cnpj: currentEmpresa
            });
          }
        }
      }

      return Promise.resolve(arrArquivos);
    } catch (error) {
      console.error(error);
      return Promise.reject(error);
    }
  }

  async getByEmpresas(empresas = []) {
    let arrArquivos = [];

    try {
      for (let cEmpresa of empresas) {
        const arquivosCollection = this._empresasCollection
          .doc(cEmpresa)
          .collection("Arquivos");
        //.where('ativo', '==', true)
        let arquivosQuerySnap = await arquivosCollection.get();
        if (!arquivosQuerySnap.empty) {
          for (let cArquivo of arquivosQuerySnap.docs) {
            let arquivoData = cArquivo.data();
            let colaborador = await this._colaboradorCollection
              .doc(arquivoData.colaborador)
              .get();
            let campanha = null;
            if (arquivoData.campanha) {
              campanha = await this._campanhasCollection
                .doc(arquivoData.campanha)
                .get();
            }
            colaborador = colaborador.data();
            campanha = campanha ? campanha.data() : null;

            let nomeColab = "";
            nomeColab = colaborador
              ? colaborador.nome
              : arquivoData.colaborador;
            nomeColab = nomeColab == "public" ? "Todos" : nomeColab;

            arrArquivos.push({
              id: cArquivo.id,
              colaborador: nomeColab,
              campanha: campanha ? campanha.nome : "",
              ativo: arquivoData.ativo,
              dataCriacao: arquivoData.dataCriacao,
              tipo: arquivoData.tipo,
              url: arquivoData.url,
              nome: arquivoData.nome,
              cnpj: cEmpresa
            });
          }
        }
      }

      return Promise.resolve(arrArquivos);
    } catch (error) {
      console.error(error);
      return Promise.reject(error);
    }
  }

  async updateAtivo(arquivoId, cnpj, ativo) {
    try {
      let arquivo = await this._empresasCollection
        .doc(cnpj)
        .collection("Arquivos")
        .doc(arquivoId)
        .update({ ativo });
      return Promise.resolve();
    } catch (error) {
      console.error(error);
      return Promise.reject(error);
    }
  }

  /* Desativar arquivos da campanha */
  async updateArquivosCampanha(campanha) {
    try {
      this._loading.setLoading(true, "Atualizando Arquivos da Campanha");

      const arquivosDocs = await this._db
        .collectionGroup("Arquivos")
        .where("campanha", "==", campanha.id)
        .where("ativo", "==", !campanha.ativo)
        .get();

      const arquivosGroups = Functions.dividirArray(arquivosDocs.docs, 500);

      for (const arquivos of arquivosGroups) {
        await this._db.runTransaction(async t => {
          for (const arquivo of arquivos) {
            const [prefix, _] = arquivo.ref.path.split("-");
            if (prefix === this._prefix) {
              await t.update(arquivo.ref, { ativo: campanha.ativo });
            }
          }
        });
      }

      return Promise.resolve("Sucesso");
    } catch (error) {
      console.error(error);
      return Promise.reject(error);
    } finally {
      this._loading.setLoading(false);
    }
  }
}
